import { TreeItemTypes } from '@common/models';

export const isDisplayFile = (item: { TreeItemType: TreeItemTypes; Type: boolean }): boolean => {
  return (item.TreeItemType === TreeItemTypes.File || item.TreeItemType === TreeItemTypes.SiteBlockItem) && Boolean(item.Type);
};
